import { Download, Plus } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { exportFlights } from "../../api/orders";

interface OrdersHeaderProps {
  onCreateOrder: () => void;
}

export function OrdersHeader({ onCreateOrder }: OrdersHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-3xl font-bold text-gray-900">Таблица заказов</h1>
      <div className="flex gap-2">
        <Button onClick={exportFlights} variant="outline" className="gap-2">
          <Download className="w-4 h-4" />
          Экспорт таблицы
        </Button>
        <Button onClick={onCreateOrder} variant="default" className="gap-2">
          <Plus className="w-4 h-4" />
          Создать заказ
        </Button>
      </div>
    </div>
  );
}
